/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  SortOrder,
  PastActionForResource,
  FutureActionForResource,
  PastActionsForResourceSortFields,
  FutureActionsForResourceSortFields,
} from "~/generated/graphql";
import { QuerySearch } from "~/components/SearchInput/types";
import { capitalize } from "~/tools";

export enum ActionTiming {
  pastCurrent = "PAST_CURRENT",
  future = "FUTURE",
}

export const actionTimingOptions = [
  {
    label: capitalize(ActionTiming.pastCurrent).replace("_", "/"),
    value: ActionTiming.pastCurrent,
  },
  {
    label: capitalize(ActionTiming.future),
    value: ActionTiming.future,
  },
];

export type PastActionForResourceWithResourceId = PastActionForResource & {
  resourceId: string;
};

export type FutureActionForResourceWithId = FutureActionForResource & {
  id: string;
};

export type ResourceDetailsActionsQuery = {
  page: string;
  limit: string;
  field?: PastActionsForResourceSortFields | FutureActionsForResourceSortFields;
  order?: SortOrder;
  actionTiming: ActionTiming;
  resourceStatuses: string[];
  excludeResourceStatuses: boolean;
  actionNames: string[];
  excludeActionNames: boolean;
  actionTypes: string[];
  excludeActionTypes: boolean;
  actionLogOutputs: string[];
  excludeActionLogOutputs: boolean;
} & QuerySearch;
